import { Carousel } from 'primereact/carousel';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Card from '../common/Card/Card';
import { useTheme } from '../../hooks/useTheme';

interface CarouselItem {
  id: number;
  title: string;
  description: string | string[];
  image?: string;
  action?: () => void;
  actionLabel?: string;
}

const getThemeBasedImage = (title: string, isLightTheme: boolean): string => {
  const themeFolder = isLightTheme ? 'light-theme-cards' : 'dark-theme-cards';

  const imageMap: { [key: string]: string } = {
    'RAN SW Onboarding ': 'RAN SW Onboarding.jpg',
    'KPI Analytics': 'KPI Analytics.jpg',
    'Network Impact Intelligence': isLightTheme ? 'Network Impact Intelligence.png' : 'Network Impact Intelligence.jpg',
    'CNIS SW Onboarding': isLightTheme ? 'CNIS SW Onboarding.png' : 'CNIS SW Onboarding.jpg',
    'Test Management, Orchestration and Report Automation': isLightTheme
      ? 'Test Management, Orchestration and report automation.jpg'
      : 'Test management, orchestration and report automation.jpg',
    'NetPulse for Advanced Network KPI Analysis': isLightTheme
      ? 'NetPulse for Advanced Network KPI Analysis.png'
      : 'NetPulse for Advanced Newtwork KPI Analysis.jpg',
    NetOps: 'NetOps.jpg',
    'Zero Code Workflows': isLightTheme ? 'Zero code pipelines.png' : 'Zero code pipelines.jpg',
    'TraceHunt(CTR Analysis)': isLightTheme ? 'Zero code pipelines.png' : 'Zero code pipelines.jpg',
    'Workflow Designer': 'Pipeline Designer.jpg',
    'Market Place': 'Market Place.jpg',
    Insights: 'Insights.jpg',
    'AI Sense': isLightTheme ? 'Ai sense.jpg' : 'Ai Sense.jpg',
    'Plan Levels': 'Plan Levels.jpg'
  };

  const imageName = imageMap[title];
  if (!imageName) {
    return '/images/home-carousel-item-1.png';
  }

  return `/images/cards/${themeFolder}/${imageName}`;
};

const defaultItems: CarouselItem[] = [
  {
    id: 1,
    title: 'RAN SW Onboarding ',
    description: [
      'Smart workflow designed for SW flow process, orchestrated by telco-centric CI/CD pipeline.',
      'Streamlining RAN and rApp GitOps-aligned LCM automation.',
      'Orchestrating tools interoperability across network operation.'
    ],
    actionLabel: 'Read more'
  },
  {
    id: 2,
    title: 'KPI Analytics',
    description: [
      'Real-time and configurable network KPI monitoring.',
      'Advanced KPI deviation detection between new software and baseline software metrics.',
      'Network Anomaly detection by using ML techniques.'
    ],
    actionLabel: 'Read more'
  },
  {
    id: 3,
    title: 'Network Impact Intelligence',
    description: [
      'RAN new feature playbook and audit.',
      'Golden Parameter List (GPL) auditing.',
      'Customer specific Operational Impact report.',
      'Correlated trouble report assessment.'
    ],
        actionLabel: 'Read more'
  },
    {
    id: 4,
    title: 'TraceHunt(CTR Analysis)',
    description: [
      'Enhanced Call Trace Records (CTR) decoding and visualization.',
      'Deep insights into signaling behavior, message directions, and performance parameters.',
      'Flexible web-based 4G/5G trace log search.'
    ],
    actionLabel: 'Read more'
  },
  {
    id: 5,
    title: 'Test Orchestration and Automation',
    description:
      'End-to-end test management for RAN infrastructure, including Cloud RAN, purpose-built, rApps, and CNIs. Enables planning, execution, and tracking of test cases with full visibility. ',
    actionLabel: 'Read more'
  }
];

export default function HomeCarousel() {
  const { theme } = useTheme();

  const itemTemplate = (item: CarouselItem) => {
    const themeBasedImage = getThemeBasedImage(item.title, theme);
    return (
      <div className="m-2">
        <Card title={item.title} description={item.description} image={themeBasedImage} action={item.action} />
      </div>
    );
  };

  return (
    <div className="home-carousel">
      <Carousel
        value={defaultItems}
        numVisible={4}
        numScroll={1}
        className="custom-carousel"
        circular
        itemTemplate={itemTemplate}
        showNavigators={true}
        showIndicators={false}
        responsiveOptions={[
          {
            breakpoint: '1400px',
            numVisible: 3,
            numScroll: 1
          },
          {
            breakpoint: '1024px',
            numVisible: 2,
            numScroll: 1
          },
          {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1
          }
        ]}
      />
    </div>
  );
}
